'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _React = require('React');

var _React2 = _interopRequireDefault(_React);

var _reactRedux = require('react-redux');

var _Immutable = require('Immutable');

var _I18nReact = require('I18n.React.FormattedHTMLMessage');

var _I18nReact2 = _interopRequireDefault(_I18nReact);

var _reactUtils = require('react-utils');

var _ComponentWithPartials = require('UIComponents/mixins/ComponentWithPartials');

var _ComponentWithPartials2 = _interopRequireDefault(_ComponentWithPartials);

var _TimePickerButton = require('MeetingsLib/components/schedule/time/TimePickerButton');

var _TimePickerButton2 = _interopRequireDefault(_TimePickerButton);

var _TimezoneSelect = require('MeetingsLib/components/schedule/time/TimezoneSelect');

var _TimezoneSelect2 = _interopRequireDefault(_TimezoneSelect);

var _ZeroState = require('MeetingsLib/components/schedule/ZeroState');

var _ZeroState2 = _interopRequireDefault(_ZeroState);

var _BookInfoSelectors = require('MeetingsLib/selectors/BookInfoSelectors');

var _RequestStatusSelectors = require('MeetingsLib/selectors/RequestStatusSelectors');

var _TroubleshootingSelectors = require('MeetingsLib/selectors/TroubleshootingSelectors');

var _Branding = require('MeetingsBase/models/Branding');

var _Branding2 = _interopRequireDefault(_Branding);

var _UserProfile = require('MeetingsBase/models/UserProfile');

var _UserProfile2 = _interopRequireDefault(_UserProfile);

var _FormActions = require('MeetingsLib/redux/actions/FormActions');

var FormActions = _interopRequireWildcard(_FormActions);

var _isEmpty = require('transmute/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimePicker = _React2.default.createClass({
  displayName: 'TimePicker',

  mixins: [_ComponentWithPartials2.default],

  propTypes: {
    // passed
    branding: _React.PropTypes.instanceOf(_Branding2.default).isRequired,
    compact: _React.PropTypes.bool,
    profile: _React.PropTypes.instanceOf(_UserProfile2.default).isRequired,
    // loaded
    dateTimeOptions: _React.PropTypes.instanceOf(_Immutable.List).isRequired,
    duration: _React.PropTypes.number,
    isFetchingPublicGlobalBranding: _React.PropTypes.bool.isRequired,
    selectedTime: _React.PropTypes.number,
    setEventDateTime: _React.PropTypes.func.isRequired,
    setTimezone: _React.PropTypes.func.isRequired,
    troubleshotStartTimes: _React.PropTypes.instanceOf(_Immutable.List).isRequired,
    userTimezone: _React.PropTypes.string.isRequired
  },

  getClassNames: function getClassNames() {
    var compact = this.props.compact;

    return (0, _reactUtils.classNames)('time-picker width-100 m-y-8', { compact: compact });
  },
  handleSetEventDateTime: function handleSetEventDateTime(time) {
    var setEventDateTime = this.props.setEventDateTime;

    return this.partial(setEventDateTime, time);
  },
  shouldShowNoTimesMessage: function shouldShowNoTimesMessage() {
    var _props = this.props,
        dateTimeOptions = _props.dateTimeOptions,
        troubleshooting = _props.troubleshooting,
        troubleshotStartTimes = _props.troubleshotStartTimes;


    if (troubleshooting) {
      return (0, _isEmpty2.default)(troubleshotStartTimes);
    }
    return dateTimeOptions.count() === 0;
  },
  renderTroubleshootTimeButtons: function renderTroubleshootTimeButtons() {
    var _this = this;

    var _props2 = this.props,
        branding = _props2.branding,
        isFetchingPublicGlobalBranding = _props2.isFetchingPublicGlobalBranding,
        selectedTime = _props2.selectedTime,
        troubleshotStartTimes = _props2.troubleshotStartTimes,
        userTimezone = _props2.userTimezone;


    return troubleshotStartTimes.map(function (troubleshotStartTime) {
      return _React2.default.createElement(_TimePickerButton2.default, {
        key: troubleshotStartTime.time,
        branding: branding,
        disabled: troubleshotStartTime.busy,
        isFetchingPublicGlobalBranding: isFetchingPublicGlobalBranding,
        ownerEmail: troubleshotStartTime.ownerEmail,
        ownerFirstName: troubleshotStartTime.ownerFirstName,
        ownerLastName: troubleshotStartTime.ownerLastName,
        relatedEventStartTime: troubleshotStartTime.relatedEventStartTime,
        selectedTime: selectedTime,
        time: troubleshotStartTime.time,
        unavailableReason: troubleshotStartTime.reason,
        userTimezone: userTimezone,
        handleSetEventDateTime: _this.handleSetEventDateTime(troubleshotStartTime.time)
      });
    });
  },
  renderTimePickerButtons: function renderTimePickerButtons() {
    var _this2 = this;

    var _props3 = this.props,
        dateTimeOptions = _props3.dateTimeOptions,
        selectedTime = _props3.selectedTime,
        userTimezone = _props3.userTimezone,
        branding = _props3.branding,
        isFetchingPublicGlobalBranding = _props3.isFetchingPublicGlobalBranding;


    return dateTimeOptions.sort().map(function (time) {
      return _React2.default.createElement(_TimePickerButton2.default, {
        key: time,
        disabled: false,
        branding: branding,
        handleSetEventDateTime: _this2.handleSetEventDateTime(time),
        isFetchingPublicGlobalBranding: isFetchingPublicGlobalBranding,
        selectedTime: selectedTime,
        time: time,
        userTimezone: userTimezone
      });
    });
  },
  renderInputs: function renderInputs() {
    var _props4 = this.props,
        profile = _props4.profile,
        troubleshooting = _props4.troubleshooting;


    if (this.shouldShowNoTimesMessage()) {
      return _React2.default.createElement(_ZeroState2.default, { profile: profile, compact: false });
    }

    var buttons = troubleshooting ? this.renderTroubleshootTimeButtons() : this.renderTimePickerButtons();

    return _React2.default.createElement(
      'div',
      { className: 'time-list-container p-x-1 overflow-y-auto' },
      buttons
    );
  },
  renderTimezoneSelect: function renderTimezoneSelect() {
    var _props5 = this.props,
        setTimezone = _props5.setTimezone,
        userTimezone = _props5.userTimezone,
        branding = _props5.branding,
        isFetchingPublicGlobalBranding = _props5.isFetchingPublicGlobalBranding;

    return _React2.default.createElement(_TimezoneSelect2.default, {
      style: { width: 'auto' },
      setTimezone: setTimezone,
      userTimezone: userTimezone,
      branding: branding,
      isFetchingPublicGlobalBranding: isFetchingPublicGlobalBranding,
      placement: 'bottom'
    });
  },
  render: function render() {
    if (!this.props.duration) {
      return null;
    }

    return _React2.default.createElement(
      'div',
      { className: this.getClassNames() },
      _React2.default.createElement(
        'h5',
        { className: 'm-bottom-1' },
        _React2.default.createElement(_I18nReact2.default, { message: 'prebook.timePicker.header' })
      ),
      this.renderTimezoneSelect(),
      this.renderInputs()
    );
  }
});

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    // Rerenders component in response to translation
    activeLocale: state.activeLocale,

    troubleshotStartTimes: (0, _TroubleshootingSelectors.troubleshotStartTimesForSelectedDate)(state),
    troubleshooting: (0, _TroubleshootingSelectors.isTroubleshootingSelector)(state),
    dateTimeOptions: (0, _BookInfoSelectors.getDateTimeOptions)(state),
    duration: (0, _BookInfoSelectors.getEvent)(state).duration,
    isFetchingPublicAvailability: (0, _RequestStatusSelectors.getIsFetchingPublicAvailability)(state),
    isFetchingPublicGlobalBranding: (0, _RequestStatusSelectors.getIsFetchingPublicGlobalBranding)(state),
    selectedTime: (0, _BookInfoSelectors.getEvent)(state).dateTime,
    userTimezone: state.userTimezone
  };
}, _extends({}, FormActions))(TimePicker);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/schedule/time/TimePicker.js
// module id = 443
// module chunks = 0